import { useAuth } from "@/contexts/auth-context";
import { SECTION_CONFIGS, type AdminSection } from "../../../../shared/index";
import { Link } from "react-router-dom";

export default function DashboardHome() {
  const { user } = useAuth();
  const permissions = user?.permissions;
  const sections = SECTION_CONFIGS.filter(
    (s) => !s.hidden && permissions?.[s.key as AdminSection]
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Welcome, {user?.name}</h1>
        <p className="text-sm text-muted-foreground">
          {sections.length > 0
            ? "Pick a section to manage."
            : "You don't have any section permissions yet. Ask an administrator."}
        </p>
      </div>

      {sections.length > 0 && (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {sections.map((section) => (
            <Link
              key={section.key}
              to={section.href}
              className="rounded-lg border border-border bg-card p-4 transition-colors hover:bg-accent"
            >
              <p className="font-semibold">{section.label}</p>
              <p className="mt-1 text-sm text-muted-foreground">
                {section.description}
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
